export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const AUTH = {
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginSubmit: 'login-submit',
  signupCompany: 'signup-company',
  signupName: 'signup-name',
  signupEmail: 'signup-email',
  signupPassword: 'signup-password',
  signupSubmit: 'signup-submit',
};

export const SHELL = {
  sidebar: 'app-sidebar',
  sidebarToggle: 'sidebar-toggle',
  themeToggle: 'theme-toggle',
  topbar: 'app-topbar',
  commandBar: 'command-bar',
  commandInput: 'command-input',
  notificationBell: 'notification-bell',
  supportWidget: 'support-widget',
};

export const LOADS = {
  createButton: 'create-load-button',
  table: 'loads-table',
  statusFilter: (status) => `status-filter-${status}`,
};

export const DISPATCH = {
  board: 'dispatch-board',
  column: (status) => `dispatch-column-${status}`,
  card: (loadId) => `load-card-${loadId}`,
};